import React from "react";
import SpecialCard from "../components/SpecialCard";
import specialsData from "./specialData";
import Specials from "../components/Specials";
import menuData from "./menuData"; 

function MenuPage() {
  return (
    
    <section className="menu-page">
      <div className="menu-header">
        <h1>Our Menu</h1>
      </div>

      <div className="menu-category">
        <h2>Starters</h2>
        <div className="menu-items">
          {menuData.starters.map((item, index) => (
            <SpecialCard 
              key={index}
              image={item.image}
              name={item.name}
              price={item.price}
              description={item.description}
            />
          ))}
        </div>
      </div>

      <div className="menu-category">
        <h2>Main Courses</h2>
        <div className="menu-items">
          {menuData.mainCourses.map((item, index) => (
            <SpecialCard 
              key={index}
              image={item.image}
              name={item.name}
              price={item.price}
              description={item.description}
            />
          ))}
        </div>
      </div>

      <div className="menu-category">
        <h2>Desserts</h2>
        <div className="menu-items">
          {menuData.desserts.map((item, index) => (
            <SpecialCard 
              key={index}
              image={item.image}
              name={item.name}
              price={item.price}
              description={item.description}
            />
          ))}
        </div>
      </div>

      <Specials specials={specialsData} />
    </section>
  );
}

export default MenuPage;
